export const getTextEstadoFoto = (estado: string) => {
  switch (estado) {
    case 'BO':
      return 'Borrada';
    case 'PV':
      return 'Pendiente de validar';
    case 'VA':
      return 'Validada';
    case 'RZ':
      return 'Rechazada';
    default:
      return estado;
  }
};
